<template>
  <div>
    <b-input-group>
      <b-form-input
        id="input_customer"
        size="sm"
        :disabled="this.$props.isDisabled"
        :state="state"
        v-model="query"
        placeholder="Все заказчики"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"
      />

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || this.$props.isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-input-customer" v-if="isFocus">
        <b-list-group-item
          v-for="(item, index) in items"
          :key="index"
          @mousedown="onClick(item)"
          button
          class="text-small"
        >
          {{ getItemListText(item) }}
        </b-list-group-item>
      </b-list-group>
    </b-input-group>
  </div>
</template>

<script>
import customers from "../../network/customers";

export default {
  name: "CustomerSelect",
  mixins: [ customers ],
  props: {
    isDisabled: Boolean,
    state: { type: Boolean, default: null },
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      item: null,
    }
  },
  methods: {
    async configure(id) {
      if (id > 0) {
        const item = (await this.getCustomerById(id)).data;
        if (item != null) {
          this.query = item.name;
          this.item = item;
          return;
        }
      }

      this.query = "";
      this.item = null;
      this.items = await this.getItems(this.query);
    },
    async onFocusIn() {
      if (this.query === "" && this.items.length === 0) {
        this.items = await this.getItems(this.query);
      }
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClear() {
      this.query = "";
      this.$emit('onSelect',0);
    },
    onClick(item) {
      this.query = item.name;
      this.item = item;
      this.$emit('onSelect',item.id);
    },
    getItemListText(item) {
      return item.name;
    },
    async getItems(query) {
      const result = await this.getCustomersSearch(query);
      if (result.data != null) {
        return result.data;
      } else {
        return [];
      }
    }
  },
  watch: {
    'query': {
      handler: async function () {
        if (this.query != null) {
          const queryLower = this.query.toLowerCase();
          this.items = await this.getItems(queryLower);
        }
      },
      deep: true
    },
  }
}
</script>

<style>
.autocomplete-input-customer {
  max-height: 250px;
  margin-top: 31px;
  min-width: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 5;
}

.autocomplete-input-customer .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Customers/CustomerSelect.vue